export default {
  promotional_text: 'Risparmia tempo e guadagna premi!',
  description:
    "L'app {{name}} è qui – per ordinare ancora più facilmente:\n\n• Ordini velocissimi tramite app\n\n• Notifiche immediate su promozioni e premi\n\n• Accumula e riscatta i tuoi punti con facilità\n\n• Segui lo stato del tuo ordine in tempo reale\n\nSiamo felici di offrirti la nostra app – e speriamo che ti diverta quanto noi!`",
  keywords: 'Ordine mobile, App ristorante, App cibo, Ritiro, Ordina cibo, Asporto, Servizio consegna',
};
